// Generated by ts-to-zod
import { z } from 'zod';
import { idSchema } from '../../utils/codecUtils.schema';

export const pagesQuerySchema = z.object({
  id: z.union([idSchema, z.array(idSchema)]).optional(),
  annotation: z.union([idSchema, z.array(idSchema)]).optional(),
  number: z.union([z.number(), z.array(z.number())]).optional(),
  ordering: z
    .union([
      z.literal('id'),
      z.literal('-id'),
      z.literal('number'),
      z.literal('-number'),
    ])
    .optional(),
  pageSize: z.number().optional(),
  page: z.number().optional(),
});
